import ScreenSet from './ScreenSet.vue'
let test = {}
test.install = function (Vue, options) {
  Vue.component(ScreenSet.name, ScreenSet) // ScreenSet.name 组件的name属性
}
export default test



// WEBPACK FOOTER //
// ./src/lib/index.js